import React, { useLayoutEffect, useRef } from 'react';
import { useRouter } from '../../components';
import { SiteLink } from '../../components';
import BottomDrawer from '../../components/bottomDrawer'

export function BottomDock(props) {
  const links = [
    { 
      url: '/services', 
      title: 'Services', 
      icon: 'Services.png', 
      iconHover: 'Services-green.png' 
    },
    { 
      url: '/consultations', 
      title: 'Consultations', 
      icon: 'Consultations.png', 
      iconHover: 'Consultations-green.png' 
    },
    {
      url: '/chooz-to-looz', 
      title: 'Chooz-to-looz',
      icon: 'Chooz-to-Looz.png', 
      iconHover: 'Chooz-to-Looz-green.png' 
    },
    { 
      url: '/products', 
      title: 'Products', 
      icon: 'Products.png', 
      iconHover: 'Products-green.png' 
    },
    { 
      url: '/news', 
      title: 'News', 
      icon: 'News.png', 
      iconHover: 'News-green.png' 
    }
  ];

  //const path = usePath();
  const { pathname } = useRouter();

  const isCurrent = (link) => {
    return pathname && pathname.toLowerCase() === link.toLowerCase();
  }

  const linkElts = links.map((link, index) =>
    <li key={index} className={`bottomMenu__li ${isCurrent(link.url) ? 'selected' : ''}`}>
      <SiteLink to={link.url} className={`bottomMenu__link bottomMenu__link--${index}`}>
        <div className="icon">
          <img className="normal" src={`/assets/navicons/${link.icon}`} alt={link.title} />
          <img className="selected" src={`/assets/navicons/${link.iconHover}`} alt={link.title} />
        </div>
        <div>{link.title}</div>
      </SiteLink>
    </li>
  );



  return (
    <>
      <nav className="bottomMenu">
        {/* <div className="bottomMenu__bg"></div> */}
        <ul className="bottomMenu__links">
          {linkElts}
        </ul>
      </nav>
    </>
  );
}
